import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Phase 12 — Guided empty state. Max 3 big action cards (German), no bare
 * tables. Pass `cards` as [{ icon, title, body, to, onClick, testid }].
 */
export default function EmptyStateCards({ title, subtitle, cards, testid = "empty-state", primaryTestid }) {
  const nav = useNavigate();
  return (
    <div className="py-10 px-6" data-testid={testid}>
      <div className="max-w-3xl mx-auto text-center mb-8">
        <h2 className="text-xl font-semibold text-white">{title}</h2>
        {subtitle && <p className="text-sm text-slate-400 mt-2">{subtitle}</p>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
        {cards.slice(0, 3).map((c, i) => {
          const Icon = c.icon;
          const go = () => (c.onClick ? c.onClick() : c.to && nav(c.to));
          const isPrimary = primaryTestid ? c.testid === primaryTestid : i === 0 && !!primaryTestid;
          return (
            <button
              key={i}
              onClick={go}
              data-testid={c.testid || `empty-card-${i}`}
              className={`group text-left rounded-xl border transition p-5 ${
                isPrimary
                  ? "bg-emerald-500/15 border-emerald-400/60 hover:bg-emerald-500/25 shadow-lg shadow-emerald-500/20"
                  : "bg-white/[0.03] border-white/10 hover:bg-white/[0.06] hover:border-emerald-400/40"
              }`}
            >
              {Icon && (
                <div className={`h-10 w-10 rounded-lg grid place-items-center mb-3 group-hover:scale-105 transition ${
                  isPrimary ? "bg-emerald-500 text-slate-900" : "bg-emerald-500/10 text-emerald-300"
                }`}>
                  <Icon className="h-5 w-5" />
                </div>
              )}
              <div className={`text-base font-semibold mb-1 ${isPrimary ? "text-white" : "text-white"}`}>{c.title}</div>
              <div className="text-xs text-slate-400 leading-relaxed">{c.body}</div>
              {isPrimary && (
                <div className="mt-3 text-[11px] font-semibold text-emerald-300 uppercase tracking-wider">Empfohlen</div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
